import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider, MutationCache } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster, toast } from 'sonner';
import App from './App';
import { getErrorMessage } from '@/utils/error';
import { blockBootIfEnvWrong } from '@/utils/envGuard';

// Trava o boot se o bundle apontar pra ambiente diferente do hostname (ex: build
// local de dev sem env vars apontando pra api de prod).
blockBootIfEnvWrong();

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/plus-jakarta-sans/800.css';

import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      // Se a mutation já tem onError próprio, não duplicar o toast
      if (mutation.options.onError) return;
      // Erros de subscription já exibem toast próprio no interceptor do api.ts
      if ((error as { _subscriptionError?: boolean })._subscriptionError) return;
      toast.error(getErrorMessage(error));
    },
  }),
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 5000,
            style: { fontSize: '14px' },
          }}
          richColors
          closeButton
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
